import { Controller } from "@hotwired/stimulus"

// Rotation automatique entre plusieurs sponsors en plein écran
export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    duration: { type: Number, default: 10 }
  }

  connect() {
    if (this.slideTargets.length > 1) {
      this.currentIndex = 0
      this.startRotation()
    }
  }

  disconnect() {
    this.stopRotation()
  }

  startRotation() {
    this.interval = setInterval(() => {
      this.nextSlide()
    }, this.durationValue * 1000)
  }

  stopRotation() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  nextSlide() {
    // Masquer slide actuel
    this.slideTargets[this.currentIndex].classList.add('hidden')

    if (this.hasIndicatorTarget) {
      this.indicatorTargets[this.currentIndex].classList.remove('bg-white')
      this.indicatorTargets[this.currentIndex].classList.add('bg-gray-500')
    }

    // Passer au suivant (avec boucle)
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length

    // Afficher nouveau slide
    this.slideTargets[this.currentIndex].classList.remove('hidden')

    if (this.hasIndicatorTarget) {
      this.indicatorTargets[this.currentIndex].classList.remove('bg-gray-500')
      this.indicatorTargets[this.currentIndex].classList.add('bg-white')
    }
  }
}
